import { render, staticRenderFns } from "./create-program.html?vue&type=template&id=5b2ba6c3&"
import script from "./create-program.js?vue&type=script&lang=js&"
export * from "./create-program.js?vue&type=script&lang=js&"
import style0 from "./create-program.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports